module.exports = __webpack_public_path__ + "static/media/customers.d0893f04.svg";